import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
import { Icon } from "./Icon.js";
const TONE_BG = {
    neutral: "bg-ivory border-ink-200 text-ink-700",
    success: "bg-success-soft border-success/30 text-success",
    warning: "bg-warning-soft border-warning/30 text-warning",
    danger: "bg-danger-soft border-danger/30 text-danger",
    info: "bg-info-soft border-info/30 text-info",
};
/**
 * Toast — single notification surface. Pairs with `ToastProvider` /
 * `useToast()` for a queued stack; can also be rendered standalone.
 *
 * ARIA: role=status + aria-live=polite by default; pass `assertive` for
 * urgent alerts (role=alert + aria-live=assertive).
 */
export function Toast({ tone = "neutral", icon, title, body, assertive, onDismiss, className, }) {
    return (_jsxs("div", { "data-slot": "toast", "data-tone": tone, role: assertive ? "alert" : "status", "aria-live": assertive ? "assertive" : "polite", className: cn("flex items-start gap-3 rounded-sm border px-4 py-3 shadow-2 max-w-sm", TONE_BG[tone], className), children: [icon ? _jsx(Icon, { name: icon, size: 18, "aria-hidden": true }) : null, _jsxs("div", { className: "flex-1 text-body-sm", children: [title ? (_jsx("p", { "data-slot": "toast-title", className: "font-medium text-ink-900", children: title })) : null, body ? (_jsx("p", { "data-slot": "toast-body", className: "text-ink-700", children: body })) : null] }), onDismiss ? (_jsx("button", { type: "button", "aria-label": "Dismiss", onClick: onDismiss, className: "text-ink-500 hover:text-ink-700 outline-none focus-visible:shadow-focus rounded-sm", children: _jsx(Icon, { name: "x", size: 16, "aria-hidden": true }) })) : null] }));
}
